import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum ZapKebabInteractionOption {
  ChangeOwner = "change_owner",
  CreateTemplate = "create_template",
  Delete = "delete",
  Duplicate = "duplicate",
  MoveToFolder = "move_to_folder",
  MoveToProject = "move_to_project",
  Rename = "rename",
  View = "view",
  ViewHistory = "view_history",
}

export function useEmitZapKebabInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: ZapKebabInteractionOption) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ZapKebab,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
